module.exports = __webpack_public_path__ + "static/20230619_181-7f34307fc7e196a2699d5e21da0bef51.jpg";